import React from "react";
import { Spin } from "antd";

import { NotificationModel } from "services/notification.service";

interface NotificationDropdownProps {
  notificationList: NotificationModel[];
  unreadCount: number;
  hasMoreNotifications: boolean;
  isFetchingNotifications: boolean;
  isMarkingAllAsRead: boolean;
  onOpenNotifications: () => void;
  onClickNotification: (item: NotificationModel) => Promise<void>;
  onLoadMoreNotifications: () => Promise<void>;
  onMarkAllAsRead: () => Promise<void>;
}

const NotificationDropdown: React.FC<NotificationDropdownProps> = ({
  notificationList,
  unreadCount,
  hasMoreNotifications,
  isFetchingNotifications,
  isMarkingAllAsRead,
  onOpenNotifications,
  onClickNotification,
  onLoadMoreNotifications,
  onMarkAllAsRead,
}) => (
  <div className="w-[380px] max-w-[calc(100vw-24px)] overflow-hidden rounded-2xl border border-[#E9EEF5] bg-white shadow-[0_16px_40px_rgba(15,23,42,0.14)]">
    <div className="border-b border-[#EEF2F7] bg-white px-4 py-3">
      <div className="flex flex-col gap-3">
        <div>
          <div className="text-[18px] font-semibold text-[#0F172A]">
            Thông báo
          </div>
          <div className="mt-0.5 text-[13px] text-[#64748B]">
            Bạn có {unreadCount} thông báo chưa đọc
          </div>
        </div>

        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={() => void onMarkAllAsRead()}
            disabled={isMarkingAllAsRead || unreadCount === 0}
            className="inline-flex h-8 items-center justify-center rounded-lg border border-[#DBEAFE] bg-[#EFF6FF] px-3 text-[12px] font-medium text-[#2563EB] hover:bg-[#DBEAFE] disabled:cursor-not-allowed disabled:opacity-50"
          >
            {isMarkingAllAsRead ? "Đang xử lý..." : "Đọc tất cả"}
          </button>

          <button
            type="button"
            onClick={onOpenNotifications}
            className="inline-flex h-8 items-center justify-center rounded-lg border border-[#E2E8F0] bg-white px-3 text-[12px] font-medium text-[#334155] hover:bg-[#F8FAFC]"
          >
            Xem tất cả
          </button>
        </div>
      </div>
    </div>

    <div className="max-h-[420px] overflow-y-auto">
      {notificationList.length > 0 ? (
        <>
          {notificationList.map((item) => (
            <div
              key={item.id}
              onClick={() => void onClickNotification(item)}
              className={`cursor-pointer border-b border-[#F5F7FB] px-4 py-3 transition-colors hover:bg-[#F8FAFC] ${
                item.status === "unread" ? "bg-[#F8FBFF]" : "bg-white"
              }`}
            >
              <div className="flex items-start gap-3">
                <div
                  className={`mt-[6px] h-[10px] w-[10px] rounded-full flex-shrink-0 ${
                    item.status === "unread" ? "bg-[#2563EB]" : "bg-[#CBD5E1]"
                  }`}
                />
                <div className="min-w-0 flex-1">
                  <div className="truncate text-[15px] font-semibold leading-5 text-[#0F172A]">
                    {item.title}
                  </div>
                  <div className="mt-1 line-clamp-2 text-[14px] leading-6 text-[#5B6B82]">
                    {item.body}
                  </div>
                  <div className="mt-2 text-[12px] text-[#94A3B8]">
                    {new Date(item.createdAt).toLocaleString("vi-VN")}
                  </div>
                </div>
              </div>
            </div>
          ))}

          {hasMoreNotifications ? (
            <div className="border-t border-[#EEF2F7] bg-white px-4 py-3">
              <button
                type="button"
                onClick={() => void onLoadMoreNotifications()}
                disabled={isFetchingNotifications}
                className="w-full rounded-xl border border-[#D9E2EC] bg-white px-4 py-2 text-[13px] font-medium text-[#334155] hover:bg-[#F8FAFC] disabled:cursor-not-allowed disabled:opacity-60"
              >
                {isFetchingNotifications ? (
                  <span className="inline-flex items-center gap-2">
                    <Spin size="small" />
                    Đang tải...
                  </span>
                ) : (
                  "Xem thêm thông báo"
                )}
              </button>
            </div>
          ) : null}
        </>
      ) : (
        <div className="px-4 py-10 text-center text-[13px] text-[#94A3B8]">
          Chưa có thông báo
        </div>
      )}
    </div>
  </div>
);

export default NotificationDropdown;
